import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBRecurringExport } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (exportProfileId: number) => {
  if (!exportProfileId) {
    throw new Error('`exportProfileId` is required');
  }
};

type RequestParams = {
  exportProfileId: number;
};

type Response = DBRecurringExport[];

export const getRecurringExportByExportProfileId = async (
  scope: RequestScope,
  { exportProfileId }: RequestParams,
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(exportProfileId);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`recurring_export?query={"export_profile_id":${exportProfileId}}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
